import { render } from "./LocationDetailView.vue?vue&type=template&id=40651f06&scoped=true"
import script from "./LocationDetailView.vue?vue&type=script&lang=js"
export * from "./LocationDetailView.vue?vue&type=script&lang=js"

import "./LocationDetailView.vue?vue&type=style&index=0&id=40651f06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40651f06"]])

export default __exports__